import { DownloadOutlined, ExportOutlined, FilterOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Divider, Dropdown, Form, message, Row, Select, Space, Typography } from "antd";
import dayjs from "dayjs";
import moment from "moment";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { DateField, InputAutocompleteField, ReactSelectField } from "../../atoms/FormElement";
import BookingStatusFilter from "../../modules/BookingListing/BookingStatusFilter";
import { SearchBar } from "../../molecules/SearchBar";
import grid from "./grid.svg";
import list from "./list.svg";

export const SectionHeaderV2 = (props: any) => {
  const {
    heading,
    total,
    importAction,
    filterAction,
    addNewAction,
    downloadAction,
    dropNewAction,
    dropItems,
    dropTrigger,
    addMoreButton,
    exportAction,
    bookingStatuses,
    cancelledBookingCheck,
    handleView,
    viewOption,
    viewOptionLabel,
    viewOptionIcon,
    viewOptionAction,
    searchByOptions,
    selectOptions,
    defaultSearch,
    onChangeSearchBy,
    onSearch,
    headReverse,
    viewRSelectOption,
    initialValue,
    onChange,
    justifiedItems,
    justifyEnd,
    bottom,
    right,
    justifyStart,
    dateAction,
    initialDate,
    headTopLeftText,
    updateValue,
    viewAutoCompleteOptions,
    justifyAEnd,
    justifyAStart,
    onAutocompleteSelect,
    onAutocompleteSearch,
    viewOptionColumn,
    filterOption,
    bookingStatus,
    bookingStatusFilter,
    bookingStatusFlag,
    checkBoxValue,
    bookingStatusTitle,
    setDateTo,
    dateTo,
    dateFrom,
    setDateFrom,
    bulkUpdate,
    modalPopuphandel,
    propertyAdminOptions,
    setDrawer,
    additionalFilters,
    resetLandloard,
    leaseScrrenDateFilters,
    currentScreen,
    setCheckBoxValue,
    filterStyle,
  } = props;

  const disableFutureDates = (current) => {
    return current && current > moment().endOf("day");
  };

  const [screenSize, setScreenSize] = React?.useState("");
  const [selectedFilterValue, setSelectedFilterValue] = useState(null);
  const [renewalDateFrom, setRenewalDateFrom] = useState(dayjs());
  const [renewalDateTo, setRenewalDateTo] = useState(dayjs().add(90, "day"));

  useLayoutEffect(() => {
    const checkScreenSize = () => {
      const width = window.innerWidth;
      if (width >= 1500) {
        setScreenSize("xl");
      } else if (width >= 992) {
        setScreenSize("lg");
      } else {
        setScreenSize("smaller than lg");
      }
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const {
    control,
    formState: { errors },
    setValue,
    getValues,
  } = useForm();

  useEffect(() => {
    const isCustom = getValues("filter");
    if (isCustom && isCustom === "custom") {
      setSelectedFilterValue(isCustom);
    }
  }, []);

  useEffect(() => {
    const views = document.querySelector("#display-views") as HTMLInputElement;
    const gridselect = document.querySelector(".grid");
    const listselect = document.querySelector(".list");
    const grid = document.querySelector(".prop-card-grid");
    listselect.addEventListener("click", () => {
      grid.classList.add("prop-list-grid");
      gridselect.classList.remove("grid-selected");
      listselect.classList.add("grid-selected");
    });
    gridselect.addEventListener("click", () => {
      grid.classList.remove("prop-list-grid");
      gridselect.classList.add("grid-selected");
      listselect.classList.remove("grid-selected");
    });
  });

  useEffect(() => {
    if (updateValue?.length > 0) {
      updateValue?.map((e) => {
        e?.label && setValue(e?.label, e?.value);
      });
    } else if (updateValue?.label) setValue(updateValue?.label, updateValue?.value);
  }, [updateValue]);

  // Handler for when "to" date changes
  const handleToDateChange = (date) => {
    if (dateFrom && date && dateFrom.isAfter(date)) {
      // Show alert if "to" date is not greater than "from" date
      message.error('The "to" date must be greater than the "from" date.');
      setDateTo(null);
    } else {
      date === null ? setDateTo(null) : setDateTo(date);
    }
  };

  const dataFrom = (date) => {
    if (date && dateTo && date.isAfter(dateTo)) {
      // Show alert if "to" date is not greater than "from" date
      message.error('The "to" date must be greater than the "from" date.');
      setDateFrom(null);
    } else {
      setDateFrom(date);
    }
  };

  const disabledStartDate = (current: any) => {
    if (!renewalDateTo) return false;
    return current.isAfter(renewalDateTo) || current.isBefore(renewalDateTo.subtract(90, "day"));
  };

  const disabledEndDate = (current: any) => {
    if (!renewalDateFrom) return false;
    return current.isBefore(renewalDateFrom) || current.isAfter(renewalDateFrom.add(90, "day"));
  };

  return (
    <>
      <Row gutter={[24, 24]} className="bc">
        <Col flex="auto">
          <Space size={8} className="h-100">
            <Typography.Title level={2} className={`custom-title32 ${total ? "borderRight" : ""}`}>
              {heading}
            </Typography.Title>

            {total && (
              <Typography.Title level={5} className="mb-0 total-title">
                {total} Total
              </Typography.Title>
            )}

            {headTopLeftText && (
              <Typography.Title level={5} className={`mb-0 total-title ${headTopLeftText ? "borderRight" : ""}`}>
                {headTopLeftText}
              </Typography.Title>
            )}
          </Space>
        </Col>
        {importAction && (
          <Col>
            <Button size="large" icon={<DownloadOutlined />} onClick={importAction}>
              Import
            </Button>
          </Col>
        )}
        {filterAction && (
          <Col>
            <Button size="large" icon={<FilterOutlined />} onClick={filterAction}>
              Filters
            </Button>
          </Col>
        )}
        {downloadAction && (
          <Col>
            <Button size="large" type="primary" className="property_card_btn" onClick={() => downloadAction()}>
              Export
            </Button>
          </Col>
        )}

        {bulkUpdate && (
          <Col>
            <Button size="large" type="primary" className="property_card_btn" onClick={() => modalPopuphandel(1)}>
              Bulk Update
            </Button>
          </Col>
        )}
        {addNewAction && (
          <Col>
            <Button size="large" type="primary" className="property_card_btn" onClick={addNewAction}>
              Add New {props.addText && props.addText} <PlusOutlined />
            </Button>
          </Col>
        )}

        {dropNewAction && (
          <Col>
            <Dropdown menu={{ items: dropItems, onClick: dropNewAction }} trigger={dropTrigger}>
              <Button size="large" type="primary" className="property_card_btn" onClick={(e) => e.preventDefault()}>
                Add New {props.addText && props.addText} <PlusOutlined />
              </Button>
            </Dropdown>
          </Col>
        )}
        {addMoreButton && (
          <Col>
            <Button
              size="large"
              type="primary"
              className="property_card_btn"
              disabled={props?.isDisabled}
              onClick={addMoreButton}
            >
              {props.addMoreText && props.addMoreText}
            </Button>
          </Col>
        )}
        {exportAction && (
          <Col>
            <Button type="primary" className="property_card_btn" icon={<ExportOutlined />} onClick={addMoreButton}>
              Export
            </Button>
          </Col>
        )}

        <Col span={24}>
          <Form
            className="ag-filter-bar org_form bf-main"
            style={headReverse ? { flexDirection: "row-reverse", justifyContent: "start" } : { alignItems: "start" }}
            name="property_filter"
            layout="vertical"
          >
            <Row justify="space-between" className="w-100">
              <Col lg={24} xl={12} className="w-100">
                <Row gutter={12} align="bottom">
                  {onSearch && (
                    <Col span={21}>
                      <Form.Item className="mb-0" label="Search by:">
                        <SearchBar
                          searchByOptions={searchByOptions}
                          selectOptions={selectOptions}
                          defaultSearch={defaultSearch}
                          onChangeSearchBy={onChangeSearchBy}
                          onSearch={onSearch}
                        />
                      </Form.Item>
                    </Col>
                  )}
                  {additionalFilters && currentScreen === "lease" && (
                    <Col span={2} style={{ margin: 6 }}>
                      <Form.Item className="mb-0">
                        <Button size="small" shape="round" className="ef-approve-btn" onClick={() => setDrawer(true)}>
                          More Filters
                        </Button>
                      </Form.Item>
                    </Col>
                  )}
                </Row>
              </Col>
              <Col lg={24} xl={12} className="w-100">
                {viewOptionLabel && (
                  <div className="viewOptiontitle">
                    <i>
                      {viewOptionIcon ?? ""} {viewOptionLabel ?? ""}
                    </i>
                  </div>
                )}

                <Row gutter={12} justify={{ lg: "start", xl: "end" }} align="bottom">
                  {viewOption &&
                    viewOption.length > 0 &&
                    viewOption.map((item, index) => (
                      <React.Fragment key={item?.name + index}>
                        <Col style={filterStyle}>
                          <Controller
                            name={item?.name}
                            control={control}
                            defaultValue={item?.initialValue}
                            render={({ field: { onChange, value, ref } }) => (
                              <>
                                <Form.Item
                                  className="mb-0"
                                  style={justifyEnd ? { marginLeft: "9px" } : {}}
                                  label={`${item?.label} (${item?.options?.length ?? 0})`}
                                  initialValue={item?.initialValue}
                                >
                                  <Select
                                    disabled={item?.unitLoading}
                                    value={props.disabled ? "" : value}
                                    ref={ref}
                                    onChange={(e) => {
                                      onChange(e);
                                      handleView(e, item?.name ?? "");

                                      if (item?.name === "filter") {
                                        setSelectedFilterValue(e.value);
                                      }
                                    }}
                                    showSearch={item?.search === true}
                                    filterOption={(input, option) =>
                                      (option?.label ?? "").toString().toLowerCase().includes(input.toLowerCase())
                                    }
                                    labelInValue
                                    placeholder={`Select ${item?.name}`}
                                    size="large"
                                    options={item?.options}
                                  />
                                </Form.Item>
                              </>
                            )}
                          />
                        </Col>
                        {selectedFilterValue === "custom" && item?.name === "filter" && (
                          <>
                            <Col>
                              <DateField
                                label="Expiry Date From"
                                fieldname="customDateFrom"
                                classes="mb-0 ml-3"
                                control={control}
                                onChange={(e) => {
                                  handleView(e, "hasSelectedStartDate");
                                  setRenewalDateFrom(dayjs(e));
                                }}
                                initValue={dayjs()}
                                iProps={{
                                  placeholder: "Start Date",
                                  format: "DD-MM-YYYY",
                                  disabledDate: disabledStartDate,
                                }}
                              />
                            </Col>

                            <Col>
                              <DateField
                                label="Expiry Date To"
                                fieldname="customDateTo"
                                classes="mb-0 ml-3"
                                control={control}
                                onChange={(e) => {
                                  handleView(e, "hasSelectedEndDate");
                                  setRenewalDateTo(dayjs(e));
                                }}
                                initValue={dayjs().add(90, "day")}
                                iProps={{
                                  placeholder: "End Date",
                                  format: "DD-MM-YYYY",
                                  disabledDate: disabledEndDate,
                                }}
                              />
                            </Col>
                          </>
                        )}
                      </React.Fragment>
                    ))}

                  <Col className="viewby" style={{ height: "4rem" }}>
                    <div id="display-views">
                      <p>View By</p>
                      <div className="grid grid-selected">
                        <img src={grid} />
                      </div>
                      <div className="list">
                        <img src={list} />
                      </div>
                    </div>
                  </Col>

                  {bookingStatus && !leaseScrrenDateFilters && (
                    <Col>
                      <BookingStatusFilter
                        cancelledBookingCheck={cancelledBookingCheck}
                        bookingStatusTitle={bookingStatusTitle}
                        checkBoxLabel="Show Cancelled Bookings"
                        bookingStatuses={bookingStatuses}
                        bookingStatusFilter={bookingStatusFilter}
                        bookingStatusValue={bookingStatusFlag}
                        setCheckBoxValue={setCheckBoxValue}
                        checkBoxValue={checkBoxValue}
                        minWidth="15rem"
                      />
                    </Col>
                  )}
                  {leaseScrrenDateFilters && (
                    <Col>
                      <BookingStatusFilter
                        cancelledBookingCheck={currentScreen === "lease"}
                        bookingStatusTitle={bookingStatusTitle}
                        bookingStatuses={bookingStatuses}
                        bookingStatusFilter={bookingStatusFilter}
                        bookingStatusValue={bookingStatusFlag}
                        checkBoxLabel="Show Current Leases only"
                        setCheckBoxValue={setCheckBoxValue}
                        checkBoxValue={checkBoxValue}
                        currentScreen={currentScreen}
                        minWidth="15rem"
                      />
                    </Col>
                  )}
                </Row>

                {viewOptionAction && viewOption && viewOption.length > 0 && (
                  <Button
                    size="large"
                    type="primary"
                    style={{
                      marginLeft: "9px",
                      padding: "5px 14px !important",
                    }}
                    className="property_card_btn"
                    onClick={viewOptionAction}
                  >
                    <PlusOutlined />
                  </Button>
                )}
                {screenSize === "xl" && setDateTo && (
                  <>
                    <Form.Item label={leaseScrrenDateFilters ? "Start Date" : `Date From`}>
                      <DatePicker
                        style={leaseScrrenDateFilters ? { width: "150px", maxWidth: "150px" } : {}}
                        placeholder={leaseScrrenDateFilters ? "Start Date" : `Date From`}
                        disabledDate={disableFutureDates}
                        value={dateFrom}
                        onChange={(e) => {
                          dataFrom(e);
                        }}
                      />
                    </Form.Item>
                    <Form.Item label={leaseScrrenDateFilters ? "End Date" : `Date To`}>
                      <DatePicker
                        style={leaseScrrenDateFilters ? { width: "150px", maxWidth: "150px" } : {}}
                        disabledDate={disableFutureDates}
                        placeholder={leaseScrrenDateFilters ? "End Date" : `Date To`}
                        value={dateTo}
                        onChange={(e) => {
                          handleToDateChange(e);
                        }}
                      />
                    </Form.Item>

                    {additionalFilters && currentScreen === "payment" && (
                      <Form.Item>
                        <Button
                          size="small"
                          shape="round"
                          className="ef-approve-btn"
                          style={{ marginTop: "24px" }}
                          onClick={() => setDrawer(true)}
                        >
                          More Filters
                        </Button>
                      </Form.Item>
                    )}
                  </>
                )}

                {viewRSelectOption && viewRSelectOption.length && (
                  <Col
                    xs={24}
                    lg={14}
                    xl={8}
                    className={justifiedItems ? "org_form" : "wrapped-items"}
                    style={justifyEnd ? { justifyContent: "end" } : justifyStart ? { justifyContent: "start" } : {}}
                  >
                    {viewRSelectOption.map((item) => (
                      <div key={item?.name + Math.random()} style={{ marginRight: 5 }}>
                        <ReactSelectField
                          isRequired={false}
                          style={{
                            borderRadius: 8,
                            borderColor: "#ffffff",
                            minHeight: 40,
                            minWidth: 200,
                          }}
                          fieldname={item?.name}
                          label={item?.name}
                          control={control}
                          iProps={{ placeholder: item.placeholder }}
                          nav={true}
                          onChange={onChange}
                          initialValue={initialValue}
                          selectOption={item?.options?.length > 0 && item?.options}
                        />
                      </div>
                    ))}
                  </Col>
                )}

                {viewAutoCompleteOptions && viewAutoCompleteOptions.length && !propertyAdminOptions && (
                  <Col
                    xs={24}
                    lg={8}
                    xl={8}
                    className={justifiedItems ? "org_form" : "wrapped-items"}
                    style={
                      justifyAEnd && screenSize == "lg"
                        ? { justifyContent: "end" }
                        : justifyAStart
                        ? { justifyContent: "start" }
                        : {}
                    }
                  >
                    {viewAutoCompleteOptions.map((item) => (
                      <div style={{ marginLeft: 5 }} key={`${item.name}`}>
                        <InputAutocompleteField
                          // value={resetLandloard}
                          // key={`${item.name}`}
                          isRequired={false}
                          initValue={item.defaultValue}
                          onSelect={onAutocompleteSelect}
                          onSearch={onAutocompleteSearch}
                          filterOption={filterOption}
                          onChange={onChange}
                          options={item.options}
                          fieldname={item?.name}
                          label={item?.label}
                          control={control}
                          style={{ width: 300 }}
                          setValue={setValue}
                          iProps={{
                            placeholder: item.placeholder,
                            style: { marginTop: 4 },
                          }}
                          valueGot={resetLandloard?.includes("reset") && ""}
                        />
                      </div>
                    ))}
                  </Col>
                )}

                {dateAction && (
                  <Col xs={24} lg={16} xl={16} className={justifiedItems ? "org_form" : "wrapped-items"}>
                    <div style={{ paddingLeft: "14px" }}>Select Date: </div>

                    <Form.Item name="Date" label="Renewal Date" initialValue="">
                      <DateField
                        fieldname="dateSearch"
                        control={control}
                        onChange={(e) => dateAction(e)}
                        initValue={initialDate ?? ""}
                        iProps={{
                          placeholder: "DD-MM-YYYY",
                          format: "DD-MM-YYYY",
                        }}
                      />
                    </Form.Item>
                  </Col>
                )}
              </Col>
            </Row>
          </Form>
        </Col>

        {!props.noborder && !setDateTo && <Divider className="ag-border-cold9" />}
      </Row>

      {screenSize == "lg" && setDateTo && !leaseScrrenDateFilters && (
        <Row gutter={[10, 24]}>
          {
            <Col>
              <DatePicker
                style={{ borderRadius: "6px", width: "150px" }}
                size={"large"}
                disabledDate={disableFutureDates}
                placeholder="Date From"
                value={dateFrom}
                onChange={(e) => {
                  dataFrom(e);
                }}
              />
            </Col>
          }
          <Col>
            <DatePicker
              style={{ borderRadius: "6px", width: "150px" }}
              size={"large"}
              placeholder="Date To"
              disabledDate={disableFutureDates}
              value={dateTo}
              onChange={(e) => {
                handleToDateChange(e);
              }}
            />
          </Col>

          {screenSize === "lg" && setDateTo && additionalFilters && (
            <Col>
              <Form.Item style={{ marginTop: "5px" }}>
                <Button
                  className="ef-approve-btn"
                  shape="round"
                  size="small"
                  style={{ zIndex: 9 }}
                  onClick={() => setDrawer(true)}
                >
                  More Filters
                </Button>
              </Form.Item>
            </Col>
          )}
          {screenSize === "lg" && setDateTo && <Divider className="mt-0 ag-border-cold9" />}
        </Row>
      )}
    </>
  );
};
